<template>
    <dashboard-layout title="미팅 관리" topBtn fullHeight>
        <template slot="topBtn">
            <meeting-form @input="updateItem">
                <template #activator="{ attrs, on }">
                    <v-btn color="secondary" v-bind="attrs" v-on="on">미팅 생성</v-btn>
                </template>
            </meeting-form>
        </template>
        <template slot="contents">
            <meeting-list-filter class="mb-16" style="flex: 0 1 auto" />
            <template v-if="items.length">
                <div class="v-cards">
                    <meeting-list-item v-for="item in items" :key="item._id" :value="item" v-bind="{ put }" @input="updateItem" />
                </div>    
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        생성된 미팅이 없습니다.
                    </p>
                    <meeting-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text height="auto" color="transparent" class="v-btn--column">
                                <i class="icon icon-plus-lg" />
                                <span class="mt-6 mt-lg-14 grey-9--text">미팅 생성하기</span>
                            </v-btn>
                        </template>
                    </meeting-form>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import MeetingForm from "@/components/dashboard/company/meeting/form/meeting-form.vue";
import MeetingListItem from "@/components/dashboard/company/meeting/list/meeting-list-item.vue";
import MeetingListFilter from "@/components/dashboard/company/meeting/list/meeting-list-filter.vue";

export default {
    components: {
        DashboardLayout,
        MeetingForm,
        MeetingListItem,
        MeetingListFilter,
    },
    data: () => ({
        loading: false,
        meetings: [],

        limit: 10,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        items() {
            return this.meetings.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, meetings } = await api.v1.company.meetings.gets({
                    headers: { skip, limit },
                    params,
                });

                this.meetings = meetings;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        async put(item) {
            this.loading = true;
            try {
                const { meeting } = await api.v1.company.meetings.put(item);
                this.updateItem(meeting);
            } finally {
                this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.meetings.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.meetings.splice(index, 1, item);
            else {
                this.meetings = [item, ...this.meetings];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style></style>
